const state = {
	refreshCount: 0,
	rooms: {},
	reconnect: false
}

const mutations = {
	setReconnect(state, payload) {
		state.reconnect = payload
	},
	addRoom(state, payload) {
		state.rooms[payload.roomId] = {
			messages: payload.messages || []
		}
		state.rooms = Object.assign({}, state.rooms)
	},
	removeRoom(state, payload) {
		delete state.rooms[payload.roomId]
	},
	appendMessage(state, payload) {
		state.rooms[payload.roomId].messages.push({
			roomId: payload.roomId,
			clientId: payload.clientId,
			contentType: payload.contentType,
			content: payload.content,
			clientType: payload.clientType,
			orderId: payload.orderId,
			createdAt: payload.createdAt,
			readedAt: payload.readedAt
		})
		state.rooms = Object.assign({}, state.rooms)
	},
	setRoomMessages(state, payload) {
		state.rooms[payload.roomId].messages = payload.messages
		state.rooms = Object.assign({}, state.rooms)
	},
	clearRooms(state) {
		state.rooms = {}
		state.rooms = Object.assign({})
	},
	updateRefreshCount(state, payload) {
		state.refreshCount ++
	}
}

const getters = {
	getRoomMessagesByRoomId: (state) => (roomId) => {
		return state.rooms[roomId].messages || []
	},
	getUnreadCount: (state) => (roomId, clientType) => {
		try {
			const messages = state.rooms[roomId].messages || []
			return messages.filter((message) => {
				return message.readedAt === 0 && message.clientType === clientType
			}).length
		} catch (err) {
			return 0
		}
	},
	getReconnectState: (state) => {
		return state.reconnect
	}
}

const actions = {
	joinMultipleRooms({ commit, dispatch }, payload) {
		const orderId = Number(payload.order.errand_order_type === 'send'
			? payload.order.o2o_errand_order_id
			: payload.order.order_id)
		const roomIds = []
		payload.clients.forEach(async (client) => {
			try {
				roomIds.push(await dispatch('joinRoom', {
					'toClientType': client,
					'orderType': payload.order.errand_order_type,
					'orderId': orderId
				}))
				await dispatch('initialChatData', {
					roomIds: roomIds
				})
			} catch (err) {
				console.error(err)
			}
		})
	},
	joinRoom({ commit, state }, payload) {
		return new Promise((resolve, reject) => {
			this._vm.$socket.emit('join', payload, (res) => {
				if (res.code === 0) {
					commit('addRoom', {
						roomId: res.results.roomId,
						messages: []
					})
					resolve(res.results.roomId)
				} else {
					reject(res.msg)
				}
			})
		})
	},
	leaveRoom({ commit, state }, payload) {
		return new Promise((resolve, reject) => {
			this._vm.$socket.emit('leave', payload, (res) => {
				if (res.code === 0) {
					commit('removeRoom', {
						roomId: payload.roomId
					})
					resolve()
				} else {
					reject(res.msg)
				}
			})
		})
	},
	sendMessage({ commit, state }, payload) {
		return new Promise((resolve, reject) => {
			this._vm.$socket.emit('sendMessage', payload, (res) => {
				if (res.code === 0) {
					resolve()
				} else {
					reject(res.msg)
				}
			})
		})
	},
	appendMessage({ commit, state }, payload) {
		commit('appendMessage', {
			roomId: payload.roomId,
			clientId: payload.clientId,
			contentType: payload.contentType,
			content: payload.content,
			clientType: payload.clientType,
			orderId: payload.orderId,
			createdAt: payload.createdAt,
			readedAt: payload.readedAt
		})
	},
	readMessages({ commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			this._vm.$socket.emit('readMessages', payload, (res) => {
				if (res.code === 0) {
					resolve()
				} else {
					reject(res.msg)
				}
			})
		})
	},
	initialChatData({ commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			this._vm.$socket.emit('initialChatData', payload, (res) => {
				if (res.code === 0) {
					res.results.forEach((room) => {
						commit('setRoomMessages', {
							roomId: room._id,
							messages: room.messages
						})
					})
					commit('updateRefreshCount')
					resolve()
				} else {
					reject(res.msg)
				}
			})
		})
	},
	clearChatData({ commit, dispatch }, payload) {
		commit('clearRooms')
	},
	setReconnect ({ commit }, payload) {
		commit('setReconnect', payload)
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
